// Tracks, per child, the newest cheer timestamp this browser has already seen.
const KEY = "tycc_cheers_seen_v1";
export const CHEERS_EVENT = "tycc-cheers-changed";

const read = () => {
  try {
    return JSON.parse(localStorage.getItem(KEY) || "{}");
  } catch {
    return {};
  }
};

export const getSeenAt = (childId) => read()[childId] || null;

export const markSeen = (childId, cheers) => {
  if (!childId) return;
  const newest = (cheers || []).reduce((a, c) => (c.created_at > a ? c.created_at : a), "");
  const all = read();
  if (newest && newest > (all[childId] || "")) {
    all[childId] = newest;
    localStorage.setItem(KEY, JSON.stringify(all));
  }
  window.dispatchEvent(new CustomEvent(CHEERS_EVENT, { detail: { childId } }));
};

export const countUnseen = (childId, cheers, userId) => {
  const seen = getSeenAt(childId) || "";
  return (cheers || []).filter((c) => c.author_id !== userId && c.created_at > seen).length;
};
